import React from 'react';
import { SlideProps } from '../types';
import { GridContainer, ScenarioForm } from '../../comps';
import { Poppins, Spacer } from 'src/common';

export const ScenariosSlide: React.FC<SlideProps> = () => {
  return (
    <GridContainer $large $scenarios>
      <Poppins color="cflowerBlue" className="row__title" px={14}>
        To provide accurate scenario suggestions for this assessment, we need more information about your organisation.
        Your responses will help us recommend relevant scenarios.
      </Poppins>
      <Spacer $px={8} />
      <ScenarioForm />
      <Spacer $px={10} />
    </GridContainer>
  );
};
